
import angular from 'angular';
import uirouter from 'angular-ui-router';

import brand from '../../service/brand';
import user from '../../service/user';
import review from '../../service/review';


import menuLayout from '../../directive/menu-layout';
import dateFormat from '../../directive/date-format';
import starRating from '../../directive/star-rating';
import storeDateSelector from '../../directive/store-date-selector';

import routing from './reviewsRanking.routes';
import ReviewsRankingController from './reviewsRanking.controller';

export default angular.module('page.reviewsRanking', [
		uirouter,

		brand,
		user,
		review,

		menuLayout,
		dateFormat,
		starRating,
		storeDateSelector,
		'ui.bootstrap.datetimepicker',
	])
	.config(routing)
	.controller('ReviewsRankingController', ReviewsRankingController)
	.name;



// WEBPACK FOOTER //
// ./src/page/reviewsRanking/index.js